
const TIMEZONELESS_ISO_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?$/;

export const parseApiDate = (ts) => {
    if (typeof ts === 'string' && TIMEZONELESS_ISO_RE.test(ts)) {
        return new Date(`${ts}Z`);
    }
    return new Date(ts);
}

export const timeSinceTS = (ts) => {
    if (!ts) {
        return "Never";
    }
    const d = parseApiDate(ts);
    const now = new Date();
    const diff_hours = (now - d) / (1000 * 60 * 60);
    const diff_days = diff_hours / 24;
    if (diff_days < 1) {
        return "Today";
    }

    return diff_days.toFixed(0) + " days ago";
}

export const formatDateTime = (ts) => {
    if (!ts) {
        return "—";
    }
    return parseApiDate(ts).toLocaleString(undefined, {
        month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
    });
}

export const formatDateTimeUTC = (ts) => {
    if (!ts) {
        return "—";
    }
    return `${parseApiDate(ts).toLocaleString(undefined, {
        month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "UTC",
    })} UTC`;
}

export const timeUntilTS = (ts) => {
    if (!ts) {
        return "Not scheduled";
    }
    const diff_hours = (parseApiDate(ts) - new Date()) / (1000 * 60 * 60);
    if (diff_hours < 0) {
        return "Due now";
    }
    if (diff_hours < 1) {
        return "in " + Math.max(1, Math.round(diff_hours * 60)) + " min";
    }
    if (diff_hours < 24) {
        return "in " + Math.round(diff_hours) + "h";
    }
    return "in " + Math.round(diff_hours / 24) + " days";
}
